import React from 'react';
import { useIntl } from 'react-intl';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import Spinner from '@rio-cloud/rio-uikit/Spinner';

import type { CloseDialogProps } from '@/features/common/components/dialogs/common/types';

export const DialogLoadingState = ({ onClose }: CloseDialogProps) => {
    const intl = useIntl();
    return (
        <div className="bg-white min-height-200">
            <Dialog.Title title={intl.formatMessage({ id: 'intl-msg:common.loading' })} onCloseButtonClick={onClose} />
            <Dialog.Body className={'padding-15 margin-left-15'}>
                <div className="row col-xs-6">
                    <Spinner />
                </div>
            </Dialog.Body>
        </div>
    );
};
